/** Copy shared by the unauthenticated screens (brand panel). */
export const Constants = {
  brandName: 'AvaliaHub',
  tagline: 'Gestão de avaliações imobiliárias em um só lugar.',
  copyright: (year: number): string => `© ${year} AvaliaHub`,
  genericError: 'Algo deu errado, tente novamente.',
};
